module.exports = __webpack_public_path__ + "static/media/bwTheme-girl.936fbdad.svg";